import { render } from "./MessageManageModel.vue?vue&type=template&id=7dd6e948"
import script from "./MessageManageModel.js?vue&type=script&lang=js"
export * from "./MessageManageModel.js?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__